import { render, staticRenderFns } from "./shipmentAddressDisplay.vue?vue&type=template&id=45d6517f&scoped=true&"
import script from "./shipmentAddressDisplay.vue?vue&type=script&lang=js&"
export * from "./shipmentAddressDisplay.vue?vue&type=script&lang=js&"
import style0 from "./shipmentAddressDisplay.vue?vue&type=style&index=0&id=45d6517f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d6517f",
  null
  
)

export default component.exports